import { roundUpToNearest } from './roundUpToNearest';

export const TIPO_VENTA_UNIDAD = 'unidad';
export const TIPO_VENTA_PESO_MANUAL = 'peso_manual';

export function calcularLineaPesoManual({ pesoKg, precioPorKg, redondeoStep = 50, importeManual }) {
  const peso = Number(pesoKg);
  const precioKg = Number(precioPorKg);
  if (!Number.isFinite(peso) || peso <= 0) {
    return { valid: false, error: 'Ingresá un peso mayor a 0' };
  }
  if (!Number.isFinite(precioKg) || precioKg <= 0) {
    return { valid: false, error: 'Precio por kg inválido' };
  }

  const subtotalCalculado = Math.round(peso * precioKg * 100) / 100;
  let subtotalFinal = subtotalCalculado;
  let redondeoAplicado = 0;

  if (Number.isFinite(Number(importeManual)) && Number(importeManual) > 0) {
    subtotalFinal = Math.round(Number(importeManual));
    redondeoAplicado = subtotalFinal - subtotalCalculado;
  } else {
    const step = Number(redondeoStep);
    if (Number.isFinite(step) && step > 0) {
      subtotalFinal = roundUpToNearest(subtotalCalculado, step);
    } else {
      subtotalFinal = Math.round(subtotalCalculado);
    }
    redondeoAplicado = subtotalFinal - subtotalCalculado;
  }

  return {
    valid: true,
    pesoKg: peso,
    precioPorKg: precioKg,
    subtotalCalculado,
    subtotalFinal,
    redondeoAplicado
  };
}

export function lineaCarritoTotal(item) {
  if (item?.tipoVenta === TIPO_VENTA_PESO_MANUAL) {
    return Number(item.subtotalFinal ?? item.precio_linea ?? 0);
  }
  return (Number(item.precio) || 0) * (Number(item.cantidad) || 0);
}

export function isProductoPesoManual(producto) {
  if (producto?.manualWeight === true || producto?.manual_weight === true) return true;
  if (producto?.manualWeight === false || producto?.manual_weight === false) return false;
  return producto?.tipoVenta === TIPO_VENTA_PESO_MANUAL
    || producto?.tipo_venta === TIPO_VENTA_PESO_MANUAL;
}

/** Importe final venta por peso — sin centavos en UI/ticket. */
export function formatMonedaPeso(value) {
  const n = Math.round(parseFloat(value || 0));
  return `$${n.toLocaleString('es-AR')}`;
}
